export default __webpack_public_path__ + "static/media/clock-primary.cf7e3349.svg";